import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PT from 'prop-types';
import styled from 'styled-components';
import { u as useTaktId } from '../TaktIdContext/TaktIdContext-f853b17a.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-39f30e88.js';

const Label = /*#__PURE__*/styled('label').withConfig({
  componentId: "sc-storm-ui-30051113__sc-17en7ap-0"
})(["display:inline;padding:0;font-weight:bold;color:", ";"], ({
  theme
}) => theme.form.label.color);
Label.propTypes = {
  /**
   * The string `id` of the input associated with this label.
   */
  htmlFor: PT.string.isRequired
};
const InputLabel = ({
  taktId,
  taktValue,
  ...props
}) => {
  const {
    getDataTaktAttributes
  } = useTaktId({
    taktId,
    fallbackId: createStormTaktId('input-label')
  });
  return /*#__PURE__*/React__default.createElement(Label, _extends({}, getDataTaktAttributes({
    taktValue
  }), props));
};
var InputLabel$1 = InputLabel;

export { InputLabel$1 as I };
//# sourceMappingURL=InputLabel-b1569c1a.js.map
